/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Favorites_EmptyInputs */

const en_us2_exercise_personal_favorites_empty = /** @type {(inputs: Exercise_Personal_Favorites_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No favourites yet. Tap the star on an exercise's sheet.`)
};

const pt_br2_exercise_personal_favorites_empty = /** @type {(inputs: Exercise_Personal_Favorites_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum favorito ainda. Toque na estrela na ficha de um exercício.`)
};

const es_419_exercise_personal_favorites_empty = /** @type {(inputs: Exercise_Personal_Favorites_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay favoritos. Toca la estrella en la ficha de un ejercicio.`)
};

const pt_pt2_exercise_personal_favorites_empty = /** @type {(inputs: Exercise_Personal_Favorites_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não há favoritos. Toca na estrela na ficha de um exercício.`)
};

const fr_fr2_exercise_personal_favorites_empty = /** @type {(inputs: Exercise_Personal_Favorites_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun favori pour l'instant. Touche l'étoile sur la fiche d'un exercice.`)
};

const de_de2_exercise_personal_favorites_empty = /** @type {(inputs: Exercise_Personal_Favorites_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Favoriten. Tippe auf den Stern in der Übersicht einer Übung.`)
};

const it_it2_exercise_personal_favorites_empty = /** @type {(inputs: Exercise_Personal_Favorites_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancora nessun preferito. Tocca la stella nella scheda di un esercizio.`)
};

/**
* | output |
* | --- |
* | "No favourites yet. Tap the star on an exercise's sheet." |
*
* @param {Exercise_Personal_Favorites_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_favorites_empty = /** @type {((inputs?: Exercise_Personal_Favorites_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Favorites_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_favorites_empty(inputs)
	if (locale === "es-419") return es_419_exercise_personal_favorites_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_favorites_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_favorites_empty(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_favorites_empty(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_favorites_empty(inputs)
	return en_us2_exercise_personal_favorites_empty(inputs)
});
export { exercise_personal_favorites_empty as "exercise-personal.favorites_empty" }